import React, { useMemo } from "react"
import { Image, StyleSheet, Text, View } from "react-native"
import { useSelector } from "react-redux"
import { useMediaQuery } from "react-responsive"

import Gap from "./Gap"

export default function HeaderTitle(props) {
  const b = useSelector(state => state.business)
  const isMobile = useMediaQuery({ maxWidth: 767 })

  const brandImage = useMemo(() => {
    let img =
      b &&
      b.affiliation &&
      b.affiliation.scheme &&
      b.affiliation.scheme.admin &&
      b.affiliation.scheme.admin.logo
    if (!img || img === null) {
      img = b && b.branding && b.branding.admin && b.branding.admin.logo
    }
    return img
  }, [b])

  return (
    <View style={styles.main}>
      <Text
        style={[styles.title, (!isMobile || !brandImage) && styles.titleLarge]}
        textBreakStrategy={"simple"}
      >
        {props.title}
      </Text>
      <Gap size={5} horizontal />
      {!!brandImage && `${props.title}`.length > 0 && (
        <Image
          style={[styles.brandImage, !isMobile && styles.brandImageLarge]}
          source={{ uri: brandImage }}
        />
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  main: {
    flexDirection: "row",
    marginBottom: 3,
    alignItems: "center",
    justifyContent: "center",
  },

  brandImage: {
    resizeMode: "contain",
    width: 60,
    height: 60,
  },

  brandImageLarge: { width: 100 },

  title: {
    color: "white",
    fontSize: 18,
    fontFamily: "OpenSans-ExtraBold",
  },

  titleLarge: { fontSize: 24 },
})
